import { useState } from "react";

import { leadsApi } from "../services";
import { toastError, toastSuccess } from "../../../common/utils/toast";

export default function useLead() {

    const [loading, setLoading] = useState(false);

    const [lead, setLead] = useState(null);

    async function loadLead(id) {

        try {

            setLoading(true);

            const response =
                await leadsApi.getLead(id);
            
            setLead(
                response
            );

            return response;

        } finally {

            setLoading(false);

        }

    }

    async function refresh() {

        if (!lead?.lead?.id) {

            return;

        }

        await loadLead(
            lead.lead.id
        );

    }
async function deleteCurrentLead(data){

    await leadsApi.deleteLead(

        lead.lead.id,data

    );
         toastError(

"Lead Deleted"

);

}
    async function updateStatus(status) {
      
      let response=  await leadsApi.updateLeadStatus(

            lead.lead.id,

            status

        );

        setLead(previous => ({

            ...previous,

            lead: {

                ...previous.lead,

                status

            }

        }));
        toastSuccess(

"Status Updated"

);

    }

    async function updateAddress(address) {

        await leadsApi.updateLeadAddress(

            lead.lead.id,

            address

        );

        await refresh();
        toastSuccess(

"Address Saved"

);

    }

    async function uploadDocument(payload) {

        await leadsApi.uploadLeadDocument(

            lead.lead.id,

            payload

        );

        await refresh();
        toastSuccess(

"Document Uploaded"

);

    }
 async function updateLead(payload){

    const response=
        await leadsApi.updateLead(

            lead.lead.id,

            payload

        );
    setLead(previous=>({

        ...previous,

        ...payload

    }));

        await refresh();

}
    async function addRemark(text) {

        await leadsApi.addLeadRemark(

            lead.lead.id,

            text

        );

        await refresh();
        toastSuccess(

"Activity Added"

);

    }

    async function deleteDocument(documentId) {

        await leadsApi.deleteLeadDocument(

            lead.lead.id,

            documentId

        );

        await refresh();
        toastError(

"Document Deleted"

);

    }
const {
    lead: leadInfo,
    address,
    documents,
    logs,activities
} = lead || {};

   return {

    loading,

    lead: leadInfo,

    address,

    documents,

    logs,activities,

    loadLead,

    refresh,
updateLead,
    updateStatus,deleteCurrentLead,

    updateAddress,

    uploadDocument,

    deleteDocument,

    addRemark

};
}